import { render, staticRenderFns } from "./NodeSingularityActive.vue?vue&type=template&id=65367d34&"
import script from "./NodeSingularityActive.vue?vue&type=script&lang=ts&"
export * from "./NodeSingularityActive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports